import { render } from "./WarningUserModal.vue?vue&type=template&id=7ca60504"
import script from "./WarningUserModal.vue?vue&type=script&lang=js"
export * from "./WarningUserModal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/patrykslak/Documents/projekty/lauron-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__